import { ApiResponse } from '@interfaces/api-response/1.0';

export interface Decorator {
  entityId?: string;
  field: string;
  key: string;
  type?: DecoratorType;
  enforceType?: DecoratorType;
  value?: string;
  multimedia?: boolean;
  extension?: string;
}

export interface DecoratorDeleteFilters {
  field?: string;
  key?: string;
  locale?: string;
}

export interface DecoratorsResponse extends ApiResponse {
  [x: string]: any;
  decorators: Decorator[];
  value?: string;
}

export enum DecoratorType {
  CATALOG = 'Catalog',
  CATALOG_RULE = 'CatalogRule',
  MENU = 'Menu',
  STORE_IMAGE = 'StoreImage',
  BRAND_IMAGE = 'BrandImage',
  MARKETING_TAG = 'MarketingTag',
  SALES_GROUP = 'SalesGroup',
  RULE = 'Rule',
}
